import { useEffect } from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import { InputField } from "../../components/common";
import { DeleteIcon } from "../../assets";

const toNumber = (value: any) => {
  const numberValue =
    typeof value === "number" ? value : parseFloat(String(value ?? "").trim());

  return Number.isFinite(numberValue) ? numberValue : 0;
};

const VehicleDetails = ({
  setVehiclesTotalPrice,
}: {
  setVehiclesTotalPrice: (_: number) => void;
}) => {
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "vehicles",
  });

  const vehicles = useWatch({
    control,
    name: "vehicles",
  });

  useEffect(() => {
    const vehicleList = Array.isArray(vehicles) ? vehicles : [];

    const totalPrice = vehicleList.reduce((acc: number, vehicle: any) => {
      return acc + toNumber(vehicle?.quantity) * toNumber(vehicle?.price);
    }, 0);

    setVehiclesTotalPrice(totalPrice);
  }, [vehicles, setVehiclesTotalPrice]);

  return (
    <>
      <h3>Vehicle Details</h3>

      {fields.map((item, index) => (
        <article
          key={item.id}
          className="fields-wrapper vehicle-details no-wrap"
        >
          <InputField
            name={`vehicles[${index}].vehicleYear`}
            label="Year"
            inputProps={{ type: "number" }}
            rules={{ required: "This field is required" }}
          />

          <InputField
            name={`vehicles[${index}].vehicleMake`}
            label="Make"
            className="large-input"
            rules={{ required: "This field is required" }}
          />

          <InputField
            name={`vehicles[${index}].vehicleModel`}
            label="Model"
            className="large-input"
            rules={{ required: "This field is required" }}
          />

          <InputField
            name={`vehicles[${index}].quantity`}
            label="QTY"
            inputProps={{ type: "number", min: 1 }}
            rules={{ required: "This field is required" }}
          />

          <InputField
            name={`vehicles[${index}].price`}
            label="Price"
            inputProps={{ type: "number", min: 0 }}
            rules={{ required: "This field is required" }}
          />

          <span
            className="icon-button"
            onClick={() => fields.length > 1 && remove(index)}
          >
            <DeleteIcon />
          </span>
        </article>
      ))}

      <span
        className="icon-button"
        onClick={() =>
          append({
            vehicleMake: "",
            vehicleModel: "",
            vehicleYear: "",
            quantity: 1,
            price: 0,
          })
        }
      >
        + Add Vehicle
      </span>
    </>
  );
};

export default VehicleDetails;


